import { Button } from "./ui/Button";

export interface Ingredient {
  id: string;
  measurement: string;
  ingredient: string;
}

interface IngredientsSectionProps {
  ingredients: Ingredient[];
  newMeasurement: string;
  newIngredient: string;
  onMeasurementChange: (value: string) => void;
  onIngredientChange: (value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onOpenListPicker: (ing: Ingredient) => void;
  addedMsg: string;
}

export function IngredientsSection({
  ingredients,
  newMeasurement,
  newIngredient,
  onMeasurementChange,
  onIngredientChange,
  onAdd,
  onRemove,
  onOpenListPicker,
  addedMsg,
}: IngredientsSectionProps) {
  return (
    <div className="ingredients-section" style={{ marginTop: "6px" }}>
      <h3 className="subsection-title" style={{ marginTop: "10px" }}>Ingredients</h3>

      {ingredients.length > 0 && (
        <ul className="ingredient-list">
          {ingredients.map((ing, index) => (
            <li key={ing.id} className="ingredient-row">
              <span className="ingredient-text">
                {ing.measurement && <span className="ingredient-meas">{ing.measurement}</span>}
                {ing.ingredient}
              </span>
              <button
                className="btn-icon-cart"
                onClick={() => onOpenListPicker(ing)}
                title="Add to list"
              >
                <span className="material-icons" style={{ fontSize: "20px" }}>add_shopping_cart</span>
              </button>
              <button
                className="btn-icon-delete"
                onClick={() => onRemove(index)}
              >
                &times;
              </button>
            </li>
          ))}
        </ul>
      )}

      <form
        onSubmit={(e) => { e.preventDefault(); onAdd(); }}
        className="ingredient-form"
      >
        <input
          value={newMeasurement}
          onChange={(e) => onMeasurementChange(e.target.value.slice(0, 8))}
          placeholder="1 cup"
          className="ingredient-measurement"
          maxLength={8}
        />
        <input
          value={newIngredient}
          onChange={(e) => onIngredientChange(e.target.value.slice(0, 23))}
          placeholder="Flour"
          className="ingredient-name"
          maxLength={23}
        />
        <Button type="submit" size="small">Add</Button>
      </form>

      {addedMsg && (
        <p style={{ color: "#34c759", fontSize: "13px", textAlign: "center", marginTop: "8px" }}>{addedMsg}</p>
      )}
    </div>
  );
}
